// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"5877a94e","lsc":"d01a3020","others":"6b207c0c"}[chunkId] + ".chunk.js";
};